"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CountController = (function () {
    function CountController(analysisId, mmxl) {
        this._analysisId = analysisId;
        this._mmxl = mmxl;
    }
    CountController.createOR = function (input) {
        return CountController.createItem(input, "$OR");
    };
    CountController.createAND = function (input) {
        return CountController.createItem(input, "$AND");
    };
    CountController.createItem = function (input, type) {
        return { "type": type, "items": _.compact(_.pick(input, ["key", "type"])) };
    };
    CountController.prototype.generateRequest = function (countInput) {
        return this._mmxl.countAnalysis(this._analysisId, countInput);
    };
    CountController.prototype.sendRequestPlansArray = function (items, fields, plans, dates) {
        if (plans.length === 0) {
            return new Promise(function (resolve, reject) {
                resolve([]);
            });
        }
        var countInput = {
            "items": plans, "fields": fields, "filters": items, "dates": dates
        };
        return this.generateRequest(countInput);
    };
    CountController.prototype.sendRequestPlansObject = function (items, fields, plan, dates) {
        var countInput = {
            "items": [plan], "fields": fields, "filters": items, "dates": dates
        };
        return this.generateRequest(countInput);
    };
    CountController.prototype.sendRequest = function (items, fields, plans, dates) {
        if (_.isArray(plans)) {
            return this.sendRequestPlansArray(items, fields, plans, dates);
        }
        else {
            return this.sendRequestPlansObject(items, fields, plans, dates);
        }
    };
    return CountController;
}());
exports.CountController = CountController;
//# sourceMappingURL=CountController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/countController.js
// module id = 22
// module chunks = 0